import { createSlice } from '@reduxjs/toolkit'
import { emptyArr } from 'util/arrays'
import {
  SEARCHING_STARTED,
  CREATING_STARTED,
  SEARCH_USER_REQUEST,
  SEARCH_USER_FAILURE,
  SEARCH_USER_SUCCESS,
  ADD_NEW_USER_REQUEST,
  ADD_NEW_USER_SUCCESS,
  ADD_NEW_USER_FAILURE,
  CHANGE_USER_REQUEST,
  CHANGE_USER_FAILURE,
  CHANGE_USER_SUCCESS,
  RESET_STATES,
} from './types'

const defaultState = {
  search: {
    isLoading: false,
    isError: false,
    term: '',
    matchingUsers: emptyArr,
  },
  create: {
    isLoading: false,
    isError: false,
  },
  change: {
    newUserId: null,
  },
  isSearching: true,
  isCreating: false,
  isLoading: false,
}

const SLICE_NAME = 'inappcards/changeUser'
const localType = type => type.replace(`${SLICE_NAME}/`, '')

const changeUser = createSlice({
  name: SLICE_NAME,
  initialState: defaultState,
  reducers: {
    [localType(RESET_STATES)]: () => {
      return defaultState
    },
    [localType(SEARCHING_STARTED)]: draftState => {
      draftState.isSearching = true
      draftState.isCreating = false
      draftState.search = defaultState.search
    },
    [localType(CREATING_STARTED)]: draftState => {
      draftState.isSearching = false
      draftState.isCreating = true
      draftState.create = defaultState.create
    },
    [localType(CHANGE_USER_REQUEST)]: (draftState, { payload }) => {
      const { user: newUser } = payload
      draftState.isError = false
      draftState.change = {
        newUserId: newUser.id,
      }
      draftState.isLoading = true
    },
    [localType(CHANGE_USER_FAILURE)]: draftState => {
      draftState.change = defaultState.change
      draftState.isLoading = false
      draftState.isError = true
    },
    [localType(CHANGE_USER_SUCCESS)]: draftState => {
      draftState.change = defaultState.change
      draftState.isLoading = false
    },
    [localType(SEARCH_USER_REQUEST)]: (draftState, { payload }) => {
      const { term } = payload
      draftState.search.term = term
      draftState.search.isLoading = true
      draftState.search.isError = false
    },
    [localType(SEARCH_USER_SUCCESS)]: (draftState, { payload }) => {
      const { users: matchingUsers } = payload
      draftState.search.matchingUsers = matchingUsers
      draftState.search.isLoading = false
    },
    [localType(SEARCH_USER_FAILURE)]: draftState => {
      draftState.search.matchingUsers = []
      draftState.search.isLoading = false
      draftState.search.isError = true
    },
    [localType(ADD_NEW_USER_REQUEST)]: draftState => {
      draftState.create.isLoading = true
      draftState.create.isError = false
    },
    [localType(ADD_NEW_USER_SUCCESS)]: draftState => {
      draftState.create.isLoading = false
      draftState.create.isError = false
    },
    [localType(ADD_NEW_USER_FAILURE)]: draftState => {
      draftState.create.isLoading = false
      draftState.create.isError = true
    },
  },
})

export default changeUser.reducer
